import {InjectionToken} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';

/**
 * Injection token for ConditionFormBuilder.
 * Use this token to provide and inject custom condition form builders.
 *
 * @example
 * // Providing a custom implementation
 * providers: [
 *   { provide: CONDITION_FORM_BUILDER, useClass: MyCustomConditionFormBuilder }
 * ]
 *
 * // Injecting in a component or service
 * constructor(@Inject(CONDITION_FORM_BUILDER) private formBuilder: ConditionFormBuilder) {}
 */
export const CONDITION_FORM_BUILDER = new InjectionToken<
  ConditionFormBuilder<unknown>
>('ConditionFormBuilder');

/**
 * Abstract base class for building condition forms.
 * Extend this class to create custom form builders for different condition types.
 */
export abstract class ConditionFormBuilder<T> {
  /**
   * Creates a FormGroup for a condition.
   *
   * @param initialValue - Optional initial value to populate the form
   * @returns A configured FormGroup for the condition
   */
  abstract buildCondition(condition?: T): UntypedFormGroup;
}
